import React from "react";
import { Button, Modal } from "best-common-react";
import { useTranslation } from "react-i18next";

type TravelInfoOnlyWarningModalProps = {
  show: boolean;
  onClose: () => void;
};

const TravelInfoOnlyWarningModal: React.FC<TravelInfoOnlyWarningModalProps> = ({ show, onClose }) => {
  const { t } = useTranslation(["profile", "translation"]);

  return (
    <Modal show={show}>
      <Modal.Header>{t("translation:attention")}</Modal.Header>
      <Modal.Body>
        {t("profile:travelInfoOnlyWarning")} <a href="mailto:registro@mlb.com">registro@mlb.com</a>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          {t("translation:continue")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TravelInfoOnlyWarningModal;
